export default __webpack_public_path__ + "static/media/nfo-banner-healthcare-comp.5fed63ce.jpg";